import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { TeachersAvailabilityApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface IUseExclusionsGetProps {
  teacherId: number;
  page?: number;
  pageSize?: number;
  lastSelectedId?: number;
  active?: boolean;
}

export const useExclusionsGet = ({
  teacherId,
  page = 1,
  pageSize = 100,
  lastSelectedId,
  active,
}: IUseExclusionsGetProps) => {
  const accessToken = useAccessToken();

  const { data, isError, isLoading, isSuccess, isPending } = useQuery({
    queryKey: [
      QueryKeys.AppointmentExclusions,
      teacherId,
      page,
      pageSize,
      lastSelectedId,
      active,
    ],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(
        TeachersAvailabilityApi,
        accessToken,
      );
      return service.apiAvailabilityTeacherIdAppointmentExclusionsGet({
        teacherId,
        page,
        pageSize,
        lastSelectedId,
        active,
      });
    },
    enabled: teacherId > 0 && !!accessToken,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
  };
};
